import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MetaData from '@gerenciatd/next.app-controller.meta-data';
import Header from '@gerenciatd/next.components.header-r';
import Footer from '@gerenciatd/next.components.footer-n';
import { actions as mainActions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r';
import {
  TEXT_INFO_COLOR,
  TEXT_INFO_HEADING_LEVEL,
  TEXT_INFO_FONT_WEIGHT,
} from '@gerenciatd/next.components.text-info-n';
import Faqs from '@gerenciatd/next.components.faqs-n';
import Image from '@gerenciatd/next.components.image-n';
import CustomLink from '@gerenciatd/next.components.custom-link';
import { END } from 'redux-saga';
import { wrapper } from '@/store';
import CONTRATOS from './contratos.json';

const COMPONENT_NAME = 'TodosLosContratos';

const Contratos = ({ breadcrumbsProps, headerProps, seoInfo }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(mainActions.setCurrentSeo(seoInfo));
  }, []);
  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: 'Ver Ofertas',
    componentProduct: '',
    componentVariation: '',
  };

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Header {...breadcrumbsProps} {...headerProps} />
      <div className="Contratos">
        <div className="Contratos container">
          <Faqs
            className="Contratos__list"
            title={CONTRATOS.title}
            titleProps={{
              level: TEXT_INFO_HEADING_LEVEL.H1,
              color: TEXT_INFO_COLOR.BLUE_DARK,
              fontType: TEXT_INFO_FONT_WEIGHT.BOLD,
            }}
            listadoFAQS={CONTRATOS.listadoFAQS}
          />
        </div>
      </div>
      <div className="Contratos_Banner">
        <CustomLink
          className="Contratos_Banner-link"
          href="https://www.movistar.es/particulares/ofertas-movistar/?pid=contratos"
          forceExternal
          title="Ir a Ofertas"
          ariaLabel="Ver Ofertas"
          taggingInfo={taggingInfo}
        >
          <div className="Contratos_Banner--desktop">
            <Image
              src="/estaticos/imagenes/mod-apa/banner-ofertas-pc.jpg"
              layout="fill"
              objectFit="contain"
              alt="Ofertas Movistar"
            />
          </div>
          <div className="Contratos_Banner--mobile">
            <Image
              src="/estaticos/imagenes/mod-apa/banner-ofertas-m.jpg"
              layout="fill"
              objectFit="contain"
              alt="Ofertas Movistar"
            />
          </div>
        </CustomLink>
      </div>
      <Footer />
      <style jsx>{`
        .Contratos {
          &_Banner {
            margin-bottom: 1.5rem;
            height: 300px;
            position: relative;
            &--mobile {
              display: none;
            }
          }
          :global(.Contratos__list) {
            padding: 1.5rem 0;
            :global(.faq-item a) {
              color: inherit;
            }
          }
        }
        @media screen and (max-width: 768px) {
          .Contratos {
            &_Banner {
              height: 250px;
              &--desktop {
                display: none;
              }
              &--mobile {
                display: block;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default Contratos;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import('@gerenciatd/next13.adabyron.misc.get-static-content'),
    await import('@gerenciatd/next13.normalizers.components-header.sections'),
    await import(
      '@gerenciatd/next13.normalizers.components-header.breadcrumbs'
    ),
    await import(
      '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r'
    ),
    await import('@gerenciatd/next13.adabyron.custo.get-seo'),
  ]);

  const { context } = store.getState().main;
  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;
  const getSeo = modules[4].default;

  const seoInfo = await getSeo({
    context,
    location: `www.movistar.es/particulares/atencion-cliente/todos-los-contratos`,
  });

  store.dispatch(
    headerActions.getHeaderInfo({
      pathname: '/particulares/atencion-cliente/todos-los-contratos',
    })
  );
  store.dispatch(
    headerActions.getFooterInfo({
      pathname: '/particulares/atencion-cliente/todos-los-contratos',
    })
  );

  // HEADER USUAL PROPS
  const urlBreadcrumbs = '/static/json/header/breadcrumbs.json';
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = '/particulares/atencion-cliente/todos-los-contratos';
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getStaticContent({
    resourcePath: '/static/json/header/header_plan_r.json',
    context,
  });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));
  store.dispatch(END);

  await store.sagaTask.toPromise();
  return {
    props: {
      seoInfo,
      headerProps,
      breadcrumbsProps,
    },
  };
});
